var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vb-tabs',{staticClass:"tabbed-info"},_vm._l((_vm.tabs),function(item,index){return _c('b-tab',{key:`${_vm._uid}:${index}:${_vm.id}`,staticClass:"tabbed-info__tab",attrs:{"title":item.title}},[_c('span',{domProps:{"innerHTML":_vm._s(item.body)}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }